<template>
  <v-layout justify-center class="white">
    <v-flex xs12 sm10 md10 justify-center>
      <v-card v-if="isList">
        <v-card-text>
          <vue-good-table
            ref="my-table"
            styleClass="vgt-table striped bordered"
            :max-height=this.height
            :fixed-header="true"
            :isLoading=this.isTableLoading
            :columns="columns"
            :rows="detailList"
            :search-options="{
              enabled: true
            }">
            <template slot="loadingContent">
              <div>
                <v-progress-circular
                  :size="50"
                  :width="7"
                  color="blue"
                  indeterminate
                ></v-progress-circular>
              </div>
            </template>
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'actions'">
                <div class="text-xs-center">
                  <v-avatar
                    color="blue lighten-4"
                    class="mr-2 mt-2"
                    size="30"
                    style="cursor: pointer;"
                    @click="changeItem(props)"
                  >
                    <v-icon small>edit</v-icon>
                  </v-avatar>
                </div>
              </span>
              <span v-else>
                {{props.formattedRow[props.column.field]}}
              </span>
            </template>
          </vue-good-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="newItem">Add</v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-else>
        <v-form
          ref="form2"
        >
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 md2>
                  <v-btn fab dark small color="primary" @click="toList()">
                    <v-icon dark>arrow_back</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="editItem.name"
                      label="Sponsor Level Name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field
                    v-model="editItem.year"
                      label="Good Through"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                  <v-select
                    v-model="editItem.active"
                    :items="yesNo"
                    label="Active"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md3 class="justify-right layout px-0">
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="updateDetail()">Save</v-btn>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="editItem.sponsorNotes"
                    label="Sponsor Notes"
                    prepend-icon="notes"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="arenaSignage"
                    :items="arenaLocations"
                    label="Arena Signage Location"
                    multiple
                    prepend-icon="star"
                  >
                    <template v-slot:prepend-item>
                      <v-list-tile
                        ripple
                        @click="toggleArena"
                      >
                        <v-list-tile-action>
                          <v-icon :color="arenaSignage.length > 0 ? 'indigo darken-4' : ''">{{ icon1 }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>Select All</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="editItem.arenaNotes"
                    label="Signage Notes"
                    prepend-icon="notes"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="bannerSignage"
                    :items="bannerLocations"
                    label="Banner Location"
                    multiple
                    prepend-icon="star"
                  >
                    <template v-slot:prepend-item>
                      <v-list-tile
                        ripple
                        @click="toggleBanner"
                      >
                        <v-list-tile-action>
                          <v-icon :color="bannerSignage.length > 0 ? 'indigo darken-4' : ''">{{ icon2 }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>Select All</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="editItem.bannerNotes"
                    label="Banner Notes"
                    prepend-icon="notes"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="other"
                    :items="otherItems"
                    label="Other Items"
                    multiple
                    prepend-icon="star"
                  >
                    <template v-slot:prepend-item>
                      <v-list-tile
                        ripple
                        @click="toggleOther"
                      >
                        <v-list-tile-action>
                          <v-icon :color="other.length > 0 ? 'indigo darken-4' : ''">{{ icon3 }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>Select All</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="editItem.otherNotes"
                    label="Other Notes"
                    prepend-icon="notes"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12
                  v-for="item in sponsorLevels"
                  :key="item.value"
                >
                  <v-layout wrap mb-5>
                    <v-flex xs12>
                      <v-layout wrap>
                        <v-flex xs12 md5>
                          <span class="subheading">{{ item.name }}</span><br />
                          <span v-if="item.notes" class="caption">({{ item.notes }})</span>
                        </v-flex>
                        <v-flex xs12 md2>
                          <span class="subheading">Trade:<br /> {{ item.tradeDisplay }}</span>
                        </v-flex>
                        <v-flex xs12 md2>
                          <span class="subheading">Cash:<br /> {{ item.priceDisplay }}</span>
                        </v-flex>
                        <v-flex xs12 md2>
                          <span class="subheading">Total:<br /> {{ item.totalDisplay }}</span>
                        </v-flex>
                        <v-flex xs12 md1>
                          <v-icon @click="editLevel(item)" color="blue">edit</v-icon>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-data-table
                        :headers="itemHeaders"
                        :items="item.SponsorItems"
                        hide-actions
                        class="elevation-1"
                      >
                        <template v-slot:items="props">
                          <td class="text-xs-left"><b>{{ props.item.name }}</b>
                            <br />{{ props.item.notes }}
                            <br /><span class="red--text">{{ props.item.internalNotes }}</span>
                          </td>
                          <td class="text-xs-center">{{ props.item.quantity }}</td>
                          <td class="text-xs-center">{{ props.item.formattedDate }}</td>
                          <td class="text-xs-center">{{ props.item.status }}</td>
                          <td class="text-xs-right">{{ props.item.tradeDisplay }}</td>
                          <td class="text-xs-right">{{ props.item.priceDisplay }}</td>
                          <td class="justify-center layout px-0">
                            <v-icon @click="editTheItem(props.item)" color="blue" small>edit</v-icon>
                          </td>
                        </template>
                        <template v-slot:footer>
                        <td :colspan="itemHeaders.length" class="text-xs-right">
                          <v-btn small color="primary" flat @click="addItem(item.id)">Add Item</v-btn>
                        </td>
                      </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="justify-right layout px-0">
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="addLevel()">Add Sponsor Level</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-form>
      </v-card>
    </v-flex>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add Sponsorship</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="editItem.name"
                  label="Sponsor Level Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editItem.year"
                  label="Good Through"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                  v-model="editItem.active"
                  :items="yesNo"
                  label="Active"
                ></v-select>
              </v-flex>
              <v-flex xs12 class="justify-right layout px-0">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="saveDetail()">Save</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="levelEditDialog" max-width="500px">
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit Level</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="editLevelForm.name"
                  label="Level Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                    v-model="editLevelForm.notes"
                    label="Notes"
                  ></v-textarea>
                </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editLevelForm.trade"
                  label="Trade Amount"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editLevelForm.price"
                  label="Cash Amount"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                  v-model="editLevelForm.active"
                  :items="yesNo"
                  label="Active"
                ></v-select>
              </v-flex>
              <v-flex xs12 class="justify-right layout px-0">
                <v-btn color="error" @click="deleteLevel(editLevelForm.id)" flat>Delete</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="updateLevel()">Save</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="itemAddDialog" max-width="500px">
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add Item</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <v-flex xs12>
                <v-select
                  v-model="sponsorSelect"
                  :items="sponsorItems"
                  item-text="name"
                  item-value="value"
                  label="Default Items"
                  @change="populateItem()"
                ></v-select>
              </v-flex>
                <v-text-field
                  v-model="editItemForm.name"
                  label="Item Name"
                  :readonly="editItemForm.readonly"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="editItemForm.notes"
                  label="Notes"
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="editItemForm.internalNotes"
                  label="Internal Notes"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editItemForm.quantity"
                  label="Quantity"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editItemForm.formattedDate"
                  label="Due Date"
                  mask="##/##/####"
                  return-masked-value
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editItemForm.trade"
                  label="Trade Amount"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editItemForm.price"
                  label="Cash Amount"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                  v-model="editItemForm.order"
                  :items="itemOrders"
                  label="Order"
                ></v-select>
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                  v-model="editItemForm.status"
                  :items="statuses"
                  label="Status"
                ></v-select>
              </v-flex>
              <v-flex xs12 class="justify-right layout px-0">
                <v-btn color="primary" @click="clearItem()">Clear Form</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="saveItem()">Save</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="itemEditDialog" max-width="500px">
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit Item</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <span class="subheading"><b>{{ editItemForm.name }}</b></span>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="editItemForm.notes"
                  label="Notes"
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="editItemForm.internalNotes"
                  label="Internal Notes"
                ></v-textarea>
              </v-flex>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="menu1"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="editItemForm.formattedDate"
                        label="Due Date"
                      ></v-text-field>
                      <v-date-picker
                        ref="picker"
                        v-model="editItemForm.dueDate"
                        no-title
                        @input="menu1 = false"
                        @change="editItemForm.formattedDate = formatDate(editItemForm.dueDate)"
                      ></v-date-picker>
                    </v-menu>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editItemForm.dueDate"
                  label="Due Date"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editItemForm.quantity"
                  label="Quantity"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editItemForm.trade"
                  label="Trade Amount"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editItemForm.price"
                  label="Cash Amount"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                  v-model="editItemForm.status"
                  :items="statuses"
                  label="Status"
                ></v-select>
              </v-flex>
              <v-flex xs12 class="justify-right layout px-0">
                <v-btn color="error" @click="deleteItem(editItemForm.id)" flat>Delete</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="updateItem()">Save</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="levelDialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="600px"
      scrollable
      persistent
    >
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Sponsor Level</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <v-select
                  v-model="editItem.levelId"
                  :items="sponsorList"
                  item-text="name"
                  item-value="value"
                  label="Level"
                ></v-select>
              </v-flex>
              <v-flex xs12 class="justify-right layout px-0">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="saveLevel()">Save</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
// import moment from 'moment'

export default {
  props: ['item'],

  components: {
    VueGoodTable
  },

  data () {
    return {
      menu1: false,
      myId: this.$store.state.user.id,
      myName: this.$store.state.user.fullName,
      page: 'list',
      currentYear: 0,
      dialog: false,
      loading: false,
      isTableLoading: false,
      isMounted: false,
      isList: true,
      yesNo: ['Yes', 'No'],
      statuses: ['Not Started', 'Pending', 'In Process', 'Complete'],
      arenaLocations: [
        'Above Chutes',
        'Center Return',
        'Chute - inside',
        'Chute - outside',
        'Grand Entry',
        'Header Box',
        'Heeler Box',
        'Man Door',
        'Outgate',
        'Paddock Wall',
        'Roping Box',
        'Section F front',
        'Section G front',
        'Tack Room Wall'
      ],
      bannerLocations: [
        'Gate Entrances (5)',
        'Gold Spur Trailer Fence',
        'Hospitality Tent',
        'Main Entrance Fence',
        'Outpost Tent',
        'Paddock Top - inside',
        'Paddock Top - outside',
        'Parking Lot',
        'Section F Bar',
        'Section F Top - inside',
        'Section F Top - outside',
        'Section G Bar',
        'Section G Top - inside',
        'Section G Top - outside',
        'Shuttles',
        'Tack Room Fence',
        'Trading Post Tent',
        'Warm Up Arena'
      ],
      otherItems: [
        'Commercial',
        'Flag',
        'PA Announcement',
        'Program Ad - full page',
        'Program Ad - half page',
        'Scoreboard logo',
        'Social Media Recognition'
      ],
      arenaSignage: [],
      bannerSignage: [],
      other: [],
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      height: 0,
      columns: [
        {
          label: 'Sponsor Level',
          field: 'name',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'Expire Year',
          field: 'year',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'Active',
          field: 'active',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'Action',
          field: 'actions',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false,
          hidden: false,
          html: true,
          width: '60px'
        }
      ],
      editItem: {},
      editLevelForm: {},
      editItemForm: {},
      levelDialog: false,
      levelEditDialog: false,
      itemEditDialog: false,
      itemAddDialog: false,
      levels: [],
      sponsorList: [],
      sponsorLevels: [],
      sponsorItems: [],
      itemOrders: [],
      items: [],
      sponsorSelect: '',
      detailList: [],
      itemHeaders: [
        {text: 'Item', align: 'center', sortable: true, value: 'id'},
        {text: 'Qty', align: 'center', sortable: false, value: 'quantity'},
        {text: 'Due Date', align: 'center', sortable: false, value: 'formattedDate'},
        {text: 'Status', align: 'center', sortable: false, value: 'status'},
        {text: 'Trade', align: 'center', sortable: false, value: 'trade'},
        {text: 'Cash', align: 'center', sortable: false, value: 'price'},
        {text: 'Edit', align: 'center', sortable: false, value: 'id'}
      ]
    }
  },

  created () {
    this.currentYear = this.$store.state.currentYear

    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getItems()
    this.getDetails()
    this.getLevels()
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    allArena () {
      return this.arenaSignage.length === this.arenaLocations.length
    },
    someArena () {
      return this.arenaSignage.length > 0 && !this.allArena
    },
    icon1 () {
      if (this.allArena) return 'mdi-close-box'
      if (this.someArena) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    allBanner () {
      return this.bannerSignage.length === this.bannerLocations.length
    },
    someBanner () {
      return this.bannerSignage.length > 0 && !this.allBanner
    },
    icon2 () {
      if (this.allBanner) return 'mdi-close-box'
      if (this.someBanner) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    allOther () {
      return this.other.length === this.otherItems.length
    },
    someOther () {
      return this.other.length > 0 && !this.allOther
    },
    icon3 () {
      if (this.allOther) return 'mdi-close-box'
      if (this.someOther) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },

  methods: {
    handleResize () {
      const height = window.innerHeight - 600
      this.height = height + 'px'
    },

    toggleArena () {
      this.$nextTick(() => {
        if (this.allArena) {
          this.arenaSignage = []
        } else {
          this.arenaSignage = this.arenaLocations.slice()
        }
      })
    },

    toggleBanner () {
      this.$nextTick(() => {
        if (this.allBanner) {
          this.bannerSignage = []
        } else {
          this.bannerSignage = this.bannerLocations.slice()
        }
      })
    },

    toggleOther () {
      this.$nextTick(() => {
        if (this.allOther) {
          this.other = []
        } else {
          this.other = this.otherItems.slice()
        }
      })
    },

    async getDetails () {
      try {
        const response = await Api().get('sponsor_details/' + this.item.id)

        this.detailList = response.data
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    addLevel () {
      this.levelDialog = true
    },

    editLevel (level) {
      this.editLevelForm = level
      this.levelEditDialog = true
    },

    addItem (levelId) {
      this.editItemForm.SponsorLevelId = levelId
      this.editItemForm.formattedDate = ''
      this.itemAddDialog = true
    },

    clearItem () {
      this.sponsorSelect = ''
      this.editItemForm.readonly = false
      this.editItemForm = {}
    },

    populateItem () {
      this.editItemForm = this.items.find(({ id }) => id === this.sponsorSelect)
      this.editItemForm.readonly = true
    },

    editTheItem (item) {
      // item.dueDate = item.formattedDate
      this.editItemForm = item
      this.itemEditDialog = true
    },

    async getItems () {
      try {
        const response = await Api().get('sponsor_all_items/')

        let sponsorItem = {}

        if (response.data.length === 0) {
          this.itemOrders.push(1)
        } else {
          for (let i in response.data) {
            let j = Number(i) + 1
            this.itemOrders.push(j)
            sponsorItem.value = response.data[i].id
            sponsorItem.name = response.data[i].name

            if (response.data[i].dueDate) {
              const [year, month, day] = response.data[i].dueDate.split('-')
              response.data[i].dueDate = `${month}/${day}/${year}`
            }

            this.sponsorItems.push(sponsorItem)
            sponsorItem = {}
          }

          let k = response.data.length + 1
          this.itemOrders.push(k)
        }

        this.items = response.data
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async getSponsorLevels () {
      try {
        const response = await Api().get('sponsor_levels/' + this.editItem.id)
        this.sponsorLevels = response.data

        for (let i in this.sponsorLevels) {
          this.sponsorLevels[i].trade = Number(this.sponsorLevels[i].trade)
          this.sponsorLevels[i].tradeDisplay = this.sponsorLevels[i].trade.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

          this.sponsorLevels[i].price = Number(this.sponsorLevels[i].price)
          this.sponsorLevels[i].priceDisplay = this.sponsorLevels[i].price.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

          this.sponsorLevels[i].total = this.sponsorLevels[i].price + this.sponsorLevels[i].trade
          this.sponsorLevels[i].totalDisplay = this.sponsorLevels[i].total.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

          for (let j in this.sponsorLevels[i].SponsorItems) {
            this.sponsorLevels[i].SponsorItems[j].formattedDate = this.formatDate(this.sponsorLevels[i].SponsorItems[j].dueDate)

            this.sponsorLevels[i].SponsorItems[j].trade = Number(this.sponsorLevels[i].SponsorItems[j].trade)
            this.sponsorLevels[i].SponsorItems[j].tradeDisplay = this.sponsorLevels[i].SponsorItems[j].trade.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

            this.sponsorLevels[i].SponsorItems[j].price = Number(this.sponsorLevels[i].SponsorItems[j].price)
            this.sponsorLevels[i].SponsorItems[j].priceDisplay = this.sponsorLevels[i].SponsorItems[j].price.toLocaleString('en-US', {style: 'currency', currency: 'USD'})
          }
        }
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async getLevels () {
      try {
        const response = await Api().get('sponsor_all_levels/')
        let sponsorList = {}

        for (let i in response.data) {
          let sponsorItem = {}
          let sponsorItems = []

          sponsorList.value = response.data[i].id
          sponsorList.name = response.data[i].DefaultSponsorType.name + ' - ' + response.data[i].name

          for (let j in response.data[i].DefaultSponsorItems) {
            sponsorItem.value = response.data[i].DefaultSponsorItems[j].id
            sponsorItem.name = response.data[i].DefaultSponsorItems[j].name

            if (response.data[i].DefaultSponsorItems[j].quantity > 0) {
              sponsorItem.name = sponsorItem.name + ' - Qty = ' + response.data[i].DefaultSponsorItems[j].quantity
            }

            if (response.data[i].DefaultSponsorItems[j].price > 0) {
              sponsorItem.name = sponsorItem.name + ' - @ $' + response.data[i].DefaultSponsorItems[j].price
            }

            sponsorItems.push(sponsorItem)
            response.data[i].sponsorItems = sponsorItems
            sponsorItem = {}
          }
          this.sponsorList.push(sponsorList)
          sponsorList = {}
        }

        this.levels = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async saveDetail () {
      try {
        let response = {}

        this.editItem.UserId = this.myId
        this.editItem.SponsorCompanyId = this.item.id

        response = await Api().post('sponsor_details/', this.editItem)

        this.dialog = false
        this.getDetails()
        this.editItem = {}
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateDetail () {
      try {
        let response = {}

        this.editItem.UserId = this.myId
        this.editItem.arenaSignage = JSON.stringify(this.arenaSignage)
        this.editItem.bannerSignage = JSON.stringify(this.bannerSignage)
        this.editItem.other = JSON.stringify(this.other)
        console.log(this.editItem)

        response = await Api().put('sponsor_details/' + this.editItem.id, this.editItem)

        this.getDetails()
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async saveLevel () {
      try {
        const level = this.sponsorList.find(({ value }) => value === this.editItem.levelId)
        this.editItem.levelName = level.name

        const response = await Api().post('add_sponsor_levels/', this.editItem)

        this.getSponsorLevels()
        this.levelDialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateLevel () {
      try {
        let response = await Api().put('update_sponsor_levels/' + this.editLevelForm.id, this.editLevelForm)

        this.getSponsorLevels()
        this.editLevelForm = {}
        this.levelEditDialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async deleteLevel (id) {
      let r = confirm('Are you sure you want to remove this Sponsor Level?')

      if (r === true) {
        try {
          const response = await Api().delete('update_sponsor_levels/' + id)

          this.getSponsorLevels()
          this.levelEditDialog = false
          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (error) {
          this.snackbar.message = error.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    },

    async saveItem () {
      try {
        // this.editItemForm.formattedDate = this.editItemForm.dueDate
        // console.log(this.editItemForm.dueDate)
        // const [month, day, year] = this.editItemForm.dueDate.split('/')

        // if (year) {
        //   this.editItemForm.dueDate = `${year}-${month}-${day}`
        // } else {
        //   this.editItemForm.dueDate = ''
        // }

        let response = await Api().post('add_sponsor_items/', this.editItemForm)

        this.getSponsorLevels()
        this.editItemForm = {}
        this.itemAddDialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateItem () {
      try {
        // this.editItemForm.formattedDate = this.editItemForm.dueDate
        // const [month, day, year] = this.editItemForm.dueDate.split('/')
        // this.editItemForm.dueDate = `${year}-${month}-${day}`

        let response = await Api().put('update_sponsor_items/' + this.editItemForm.id, this.editItemForm)

        this.editItemForm = {}
        this.itemEditDialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async deleteItem (id) {
      let r = confirm('Are you sure you want to remove this Sponsor Item?')

      if (r === true) {
        try {
          const response = await Api().delete('update_sponsor_items/' + id)

          this.getSponsorLevels()
          this.itemEditDialog = false
          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (error) {
          this.snackbar.message = error.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    },

    newItem () {
      this.editItem = {}
      this.dialog = true
    },

    changeItem (props) {
      this.editItem = props.row
      this.arenaSignage = JSON.parse(this.editItem.arenaSignage)
      this.bannerSignage = JSON.parse(this.editItem.bannerSignage)
      this.other = JSON.parse(this.editItem.other)
      this.sponsorLevels = this.editItem.SponsorLevels

      for (let i in this.sponsorLevels) {
        this.sponsorLevels[i].trade = Number(this.sponsorLevels[i].trade)
        this.sponsorLevels[i].tradeDisplay = this.sponsorLevels[i].trade.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

        this.sponsorLevels[i].price = Number(this.sponsorLevels[i].price)
        this.sponsorLevels[i].priceDisplay = this.sponsorLevels[i].price.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

        this.sponsorLevels[i].total = this.sponsorLevels[i].price + this.sponsorLevels[i].trade
        this.sponsorLevels[i].totalDisplay = this.sponsorLevels[i].total.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

        for (let j in this.sponsorLevels[i].SponsorItems) {
          this.sponsorLevels[i].SponsorItems[j].formattedDate = this.formatDate(this.sponsorLevels[i].SponsorItems[j].dueDate)

          this.sponsorLevels[i].SponsorItems[j].trade = Number(this.sponsorLevels[i].SponsorItems[j].trade)
          this.sponsorLevels[i].SponsorItems[j].tradeDisplay = this.sponsorLevels[i].SponsorItems[j].trade.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

          this.sponsorLevels[i].SponsorItems[j].price = Number(this.sponsorLevels[i].SponsorItems[j].price)
          this.sponsorLevels[i].SponsorItems[j].priceDisplay = this.sponsorLevels[i].SponsorItems[j].price.toLocaleString('en-US', {style: 'currency', currency: 'USD'})
          console.log(this.sponsorLevels[i].SponsorItems[j])
        }
      }

      this.isList = false
    },

    toList () {
      this.editItem = {}
      this.isList = true
    },

    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },

    close () {
      this.editItem = {}
      this.editLevelForm = {}
      this.editItemForm = {}
      this.dialog = false
      this.levelDialog = false
      this.levelEditDialog = false
      this.itemEditDialog = false
      this.itemAddDialog = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/sponsor/DetailList.vue